import {Mode, STORAGE_KEY} from "../model/themeSchema";

export const refreshTheme = (value: Mode) => {
    localStorage.setItem(STORAGE_KEY, value);
};
